import {useFetchData} from 'hooks/api/useFetchData'

export const useFetchAlertsCsvStatus = () => {
  const path = 'api/export_alerts_csv_request'

  return useFetchData<boolean>(path, false, {})
}
